import React from 'react';
import PropTypes from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { getSortedValue } from '../helpers';
import './specifications.scss';

export const AttributeContent = ({ attributeGroupList }) => {
  const attributeValues = getSortedValue({ attributeGroupList });
  return (
    <>
      <div className="specifications__wrapper">
        {(attributeValues || []).map((attr, i) => (
          <Col key={i} xs="12" sm="12" md="6" className="specifications__row">
            <Col fallback="6" className="specs__cell specs__cell__label">
              {attr.specName}
            </Col>
            <Col fallback="6" className="specs__cell">
              {attr.specValue}
            </Col>
          </Col>
        ))}
        {attributeValues && attributeValues.length % 2 === 1 && (
          <Col xs="12" sm="12" md="6" className="specifications__row">
            <Col fallback="6" className="specs__cell__empty specs__cell__label" />
            <Col fallback="6" className="specs__cell__empty" />
          </Col>
        )}
      </div>
    </>
  );
};

AttributeContent.displayName = 'AttributeContent';

AttributeContent.propTypes = {
  attributeGroupList: PropTypes.shape({})
};

AttributeContent.defaultProps = {
  attributeGroupList: null
};
